<script lang="ts" setup>
import type { HintedString } from 'core'

defineProps<{
  size?: HintedString<'sm' | 'xs'>
}>()
</script>

<template>
  <div
    class="h-$size w-$size block flex-shrink-0 rounded-full border-$color border-width-$width border-solid border-b-transparent animate-spin"
    :class="{
      '$size-24px $width-3px': !size,
      '$size-20px $width-2px': size === 'sm',
      '$size-16px $width-2px': size === 'xs',
    }"
  />
</template>
